import { toast } from 'react-toastify';
import { useState, useRef, useEffect } from 'react';

const DetailEquipment = ({
  equip,
  contact,
  showResModal,
  setQuantity,
  quantity,
}) => {
  const [showContact, setShowContact] = useState(false);
  const [contactHeight, setContactHeight] = useState(0);
  const contactRef = useRef(null);

  useEffect(() => {
    if (contactRef.current) {
      setContactHeight(showContact ? contactRef.current.scrollHeight : 0);
    }
  }, [showContact]);

  if (!equip || !equip._id) {
    return (
      <p className="text-center p-6 text-red-500">
        Equipment not found or still loading.
      </p>
    );
  }

  const contactInfo = contact || { firstName: '', lastName: '', email: '' };

  const handleRentEquipment = () => {
    console.log('Equipment object:', equip);
    if (!equip._id) {
      toast.error('Equipment ID is missing');
      return;
    }

    showResModal(true);
  };

  const toggleContactInfo = () => {
    setShowContact(!showContact);
  };

  return (
    <section className="overflow-hidden bg-white py-11 font-poppins">
      <div className="max-w-6xl px-4 py-4 mx-auto lg:py-8 md:px-6">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full px-4 md:w-1/2 ">
            <div className="sticky top-0 z-50 overflow-hidden ">
              <div className="relative mb-6 lg:mb-10 lg:h-2/4 ">
                <img
                  src={equip.images[0]}
                  alt=""
                  className="object-cover w-full lg:h-full "
                />
              </div>
            </div>
          </div>
          <div className="w-full px-4 md:w-1/2 ">
            <div className="lg:pl-20">
              <div className="mb-8 ">
                <h2 className="max-w-xl mt-2 mb-6 text-2xl font-bold md:text-4xl">
                  {equip.name}
                </h2>
                <p className="max-w-md mb-6 text-gray-700">
                  {equip.description}
                </p>
                <p className="inline-block text-2xl font-bold text-gray-700 ">
                  <span>${equip.rentalPrice}/Day</span>
                </p>
              </div>
              <div className="w-32 mb-6 ">
                <div className="relative flex flex-row w-full h-10 mt-4 bg-transparent rounded-lg">
                  <button
                    className="w-20 h-full text-gray-600 bg-gray-300 rounded-l outline-none cursor-pointer  hover:text-gray-700 hover:bg-gray-400"
                    onClick={() => {
                      setQuantity((state) => (state > 1 ? state - 1 : state));
                    }}
                  >
                    <span className="m-auto text-2xl font-thin">-</span>
                  </button>
                  <input
                    type="number"
                    min="0"
                    className="flex items-center w-full font-semibold text-center text-gray-700 placeholder-gray-700 bg-gray-300 outline-none focus:outline-none text-md hover:text-black"
                    value={quantity}
                    readOnly
                  />
                  <button
                    className="w-20 h-full text-gray-600 bg-gray-300 rounded-r outline-none cursor-pointer hover:text-gray-700 hover:bg-gray-400"
                    onClick={() => {
                      setQuantity((state) =>
                        equip.qty > state ? state + 1 : state,
                      );
                    }}
                  >
                    <span className="m-auto text-2xl font-thin">+</span>
                  </button>
                </div>
              </div>

              <div
                className="mb-6 overflow-hidden transition-all duration-300 ease-in-out"
                style={{
                  maxHeight: contactHeight,
                  opacity: showContact ? 1 : 0,
                  border: showContact
                    ? '1px solid #b2f5ea'
                    : '1px solid transparent',
                  borderRadius: '0.375rem',
                }}
              >
                <div ref={contactRef} className="p-4 bg-teal-50">
                  <h3 className="font-bold mb-2 text-teal-700">
                    Contact Information
                  </h3>
                  <p>
                    <span className="font-semibold">Name:</span>{' '}
                    {contactInfo?.firstName || 'N/A'}{' '}
                    {contactInfo?.lastName || ''}
                  </p>
                  <p>
                    <span className="font-semibold">Email:</span>{' '}
                    {contactInfo?.email || 'No email provided'}
                  </p>
                  {contactInfo.email ? (
                    <p className="mt-3 text-teal-600 italic">
                      Feel free to reach out if you have any questions or
                      concerns about this equipment.
                    </p>
                  ) : (
                    <p className="mt-3 text-teal-600 italic">
                      Unfortunately we could not find any contact information
                      for this equipment.
                    </p>
                  )}
                </div>
              </div>

              <div className="flex flex-wrap items-center -mx-4 ">
                <div className="w-full px-4 mb-4 lg:w-1/2 lg:mb-0">
                  <button
                    className="flex items-center justify-center
                    w-full p-3 text-teal-500 border border-teal-500
                    rounded-md hover:bg-teal-600 hover:border-teal-600 hover:text-gray-100"
                    onClick={handleRentEquipment}
                  >
                    Rent Equipment
                  </button>
                </div>
                <div className="w-full px-4 mb-4 lg:w-1/2 lg:mb-0">
                  <button
                    className="flex items-center justify-center
                    w-full p-3 text-blue-500 border border-blue-500
                    rounded-md hover:bg-blue-600 hover:border-blue-600 hover:text-gray-100"
                    onClick={toggleContactInfo}
                  >
                    {showContact ? 'Hide Contact' : 'Contact Information'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { DetailEquipment };
